var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-grid"},_vm._l((_vm.rows),function(row){return _c('tm-row',{key:row.rowId,attrs:{"row":row}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }